import ResourceMap from './resource-map';
import { fetchTypes, apiRoutes, contentTypes } from '../constants';
import { AuthActions, GrowlActions } from '../actions';
import { ResourceUtils } from '../utils';

import moment from 'moment';

export default function(){
    // Set data models for the app
    ResourceMap.resource(fetchTypes.TOKEN, {
        url: apiRoutes.TOKEN,
        method: ResourceMap.methods.POST,
        headers: {
            'Content-type': contentTypes.FORM_DATA
        },
        onSuccess: (response, status, dispatch) => {
            dispatch(AuthActions.setCurrentUser(response));
        },
        onError: (response, status, dispatch) => {
            dispatch(AuthActions.logOut());
        }
    });

    ResourceMap.resource(fetchTypes.APPROVAL_QUEUE, {
        url: apiRoutes.APPROVAL_QUEUE,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.USER_APPROVE, {
        url: apiRoutes.USER_APPROVE,
        method: ResourceMap.methods.POST,
        onSuccess: (response, status, dispatch) => dispatch(GrowlActions.notify('User approved')),
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.messsage))
    });

    ResourceMap.resource(fetchTypes.USER_REJECT, {
        url: apiRoutes.USER_REJECT,
        method: ResourceMap.methods.POST,
        onSuccess: (response, status, dispatch) => dispatch(GrowlActions.notify('User rejected')),
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.messsage))
    });

    ResourceMap.resource(fetchTypes.SAMPLE_SEARCH, {
        url: apiRoutes.SAMPLE_SEARCH,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.REPORT_SEARCH, {
        url: apiRoutes.REPORT_SEARCH,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.PENDING_REPORT_SEARCH, {
        url: apiRoutes.REPORT_SEARCH,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.REPORT_ACCESS, {
        url: apiRoutes.REPORT_ACCESS,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.REPORT_DATA, {
        url: params => apiRoutes.REPORT_DATA_BASE + params.reportId,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.FORGOT_PASSWORD, {
        url: apiRoutes.FORGOT_PASSWORD,
        method: ResourceMap.methods.POST
    });

    ResourceMap.resource(fetchTypes.RESET_PASSWORD, {
        url: apiRoutes.RESET_PASSWORD,
        method: ResourceMap.methods.POST
    });

    ResourceMap.resource(fetchTypes.CHANGE_PASSWORD, {
        url: '/api/account/change-password',
        method: ResourceMap.methods.POST,
        onSuccess: (response, status, dispatch) => dispatch(GrowlActions.notify('Your password was successfully changed.')),
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.message))
    });

    ResourceMap.resource(fetchTypes.USER_SEARCH, {
        url: apiRoutes.USER_SEARCH,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.GET_SECURITY, {
        url: apiRoutes.GET_SECURITY,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.USER_REVOKED_SEARCH, {
        url: apiRoutes.USER_REVOKED_SEARCH,
        method: ResourceMap.methods.GET
    });

    ResourceMap.resource(fetchTypes.USER_REVOKE_ACCESS, {
        url: apiRoutes.USER_REVOKE_ACCESS,
        method: ResourceMap.methods.POST,
        onSuccess: (response, status, dispatch) => dispatch(GrowlActions.notify('User successfully revoked.')),
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.message))
    });

    ResourceMap.resource(fetchTypes.USER_RESTORE_ACCESS, {
        url: apiRoutes.USER_RESTORE_ACCESS,
        method: ResourceMap.methods.POST,
        onSuccess: (response, status, dispatch) => dispatch(GrowlActions.notify('User successfully restored.')),
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.message))
    });

    ResourceMap.resource(fetchTypes.COMPLETED_REPORT_SEARCH_EXPORT, {
        url: apiRoutes.REPORT_EXPORT_ALL,
        method: ResourceMap.methods.GET,
        responseType: 'arraybuffer',
        onSuccess: (response, status, dispatch) => {
            let blob = new Blob([response], {
                type: contentTypes.VND_OPENXML
            });

            ResourceUtils.downloadBlob(blob, {
                fileName: `Completed Reports ${moment().format('MMMM Do YYYY')}`
            });

            dispatch(GrowlActions.notify('Download complete'));
        },
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.message))
    });

    ResourceMap.resource(fetchTypes.PENDING_REPORT_SEARCH_EXPORT, {
        url: apiRoutes.REPORT_EXPORT_ALL,
        method: ResourceMap.methods.GET,
        responseType: 'arraybuffer',
        onSuccess: (response, status, dispatch) => {
            let blob = new Blob([response], {
                type: contentTypes.VND_OPENXML
            });

            ResourceUtils.downloadBlob(blob, {
                fileName: `Incoming Reports ${moment().format('MMMM Do YYYY')}`
            });

            dispatch(GrowlActions.notify('Download complete'));
        },
        onError: (response, status, dispatch) => dispatch(GrowlActions.notify(response.message))
    });

    ResourceMap.resource(fetchTypes.SET_SECURITY, {
        url: apiRoutes.SET_SECURITY,
        method: ResourceMap.methods.POST,
        onSuccess:(response, status, dispatch) => {
            dispatch(GrowlActions.notify('Security set successfully.'));
        }
    });
}



// WEBPACK FOOTER //
// ./web-app/utils/init-resources.js